/**
 * 全局配置
 * 通过 .env.development / .env.production 注入，构建时由 webpack DefinePlugin
 * 替换 process.env.VUE_APP_* 引用。
 */
const api = process.env.VUE_APP_API_BASE
const deptId = Number(process.env.VUE_APP_DEPT_ID)

export { api, deptId }

export default {
  api,
  deptId
}
